class AlternativeProducts extends HTMLElement {
  constructor() {
    super();

    const productDataScript = this.querySelector('script[type="application/json"]');

    // Ensure unavailable_variants is available globally or passed somehow
    // Assuming 'unavailable_variants' is defined in the scope where this class is used
    if (typeof unavailable_variants === 'undefined' || !productDataScript) {
      console.error("Missing required data ('unavailable_variants' or JSON script tag).");
      this.disabled = true;
      return;
    }

    this.unavailable_variants = unavailable_variants;
    this.products = JSON.parse(productDataScript.textContent);

    this.alternatives = [];

    this.itemEl = this.querySelector('[data-item]');

    if (!this.itemEl) {
      console.error('Missing data-item element inside alternative-products.');
      this.disabled = true;
      return;
    }

    this.sizeOptionsEl = document.querySelector('[name="Size"]:checked');
  }

  connectedCallback() {
    // Loop through the unavailable variants and find matching products
    this.unavailable_variants.forEach((variant) => {
      const availableProduct = this.products.find(
        (product) => product.variant_title === variant.trim() && product.available === true
      );
      if (availableProduct) {
        this.alternatives.push(availableProduct);
      }
    });

    if (!this.sizeOptionsEl) return;
    const currentSize = this.sizeOptionsEl.value;

    if (!currentSize) return;

    this.checkAlternative(currentSize);
  }

  checkAlternative(title) {
    // 1. check if 'title' is not blank or null, else, return early.
    this.itemEl.innerHTML = ''; // Clear any previous content
    if (!title || title.trim() === '') {
      // Added .trim() for blank strings
      console.log('checkAlternative: title is blank or null, returning early.');
      return;
    }

    // 2. check if there's object in this.alternatives where the 'variant_title' is same as the 'title' variable
    const foundAlternative = this.alternatives.find((alternative) => alternative.variant_title === title);

    // 3. if yes, inject the HTML
    if (foundAlternative) {
      // 5. if 'featured_image' is null, use fallback
      // 6. in the 'featured_image' append '_96x96' before the extension.
      let imageUrl = foundAlternative.featured_image;
      if (!imageUrl) {
        imageUrl = 'https://cdn.shopify.com/s/files/1/0687/6997/2364/files/no-image.jpg?v=1745203771';
      } else {
        // Split URL into base path and query string (if any)
        const parts = imageUrl.split('?');
        const path = parts[0];
        const query = parts[1] ? '?' + parts[1] : '';

        // Find the last dot in the path part
        const lastDotIndex = path.lastIndexOf('.');

        // Append _96x96 before the extension if a dot is found, otherwise just append
        if (lastDotIndex > -1) {
          const basePath = path.substring(0, lastDotIndex);
          const extension = path.substring(lastDotIndex); // Includes the dot
          imageUrl = basePath + '_96x96' + extension + query;
        } else {
          // Handle case where URL has no extension (unlikely for images, but safer)
          imageUrl = path + '_96x96' + query;
        }
      }

      // 4. if 'compare_at_price' is null OR equal to 'price', don't add extra elements
      const shouldShowComparePrice =
        foundAlternative.compare_at_price && foundAlternative.compare_at_price !== foundAlternative.price;

      const comparePriceHtml = shouldShowComparePrice ? `<span>${foundAlternative.compare_at_price}</span>` : '';

      const badgeHtml = shouldShowComparePrice ? `<span class="badge badge--sale">SALE</span>` : '';

      // Build the HTML string
      const htmlToInject = `
                <div class="alternative-products__thumbnail"><img src="${imageUrl}" width="96" height="96" alt="${
        foundAlternative.product_title || 'Product image'
      }">${badgeHtml}</div>
                <h3 class="alternative-products__title">${foundAlternative.product_title}</h3>
                <div class="price alternative-products__price">
                    <span>${foundAlternative.price}</span>
                    ${comparePriceHtml}
                </div>
                <a href="${foundAlternative.url}?variant=${
        foundAlternative.id
      }" class="button alternative-products__button">View Product<span class="arrow"></span></a>
            `;

      // Inject the HTML into the item element
      this.itemEl.innerHTML = htmlToInject;
    } else {
      console.log('checkAlternative: No alternative found for variant title:', title);
      // The element was already cleared, so no further action needed if not found.
    }
  }
}

// Register the custom element
customElements.define('alternative-products', AlternativeProducts);
